export const baseUrl = process.env.REACT_APP_API_URL;
export const springBaseUrl = process.env.REACT_APP_SPRING_API_URL;
export const gmapsAPIKey = process.env.REACT_APP_GMAPS_API_KEY;
export const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
export const razorPayKey = process.env.REACT_APP_RAZORPAY_PUBLIC_KEY;
export const ENV = process.env.REACT_APP_ENV;
export const AMPLITUDE_KEY = process.env.REACT_APP_AMPLITUDE_KEY;
